import styled from 'styled-components';
import ChatOpener from './ChatOpener';
import { colorSchema, media } from 'utils/style';

export default styled(ChatOpener)`
  .chat-opener {
    display: none;
    position: fixed;
    bottom: 2rem;
    right: 2rem;

    ${media.greaterThan('tablet')`
      display: flex;
    `}

    &__button {
      align-items: center;
      border: 0;
      background-color: ${colorSchema('primary900')};
      border-radius: 50%;
      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
      cursor: pointer;
      display: flex;
      height: 64px;
      justify-content: center;
      position: relative;
      width: 64px;
    }

    &__icon {
      fill: ${colorSchema('white')};
      height: 20px;
      width: 20px;
    }

    &__badge {
      align-items: center;
      background-color: ${colorSchema('white')};
      border: 7px solid ${colorSchema('accent700')};
      border-radius: 50%;
      color: ${colorSchema('white')};
      display: flex;
      height: 20px;
      justify-content: center;
      position: absolute;
      top: -3px;
      right: -5px;
      width: 20px;
    }
  }
`;
